import Paper, { PaperProps } from '@material-ui/core/Paper';
import { withStyles, lighten, darken } from '@material-ui/core/styles';
import React from 'react';

export default withStyles<'root', {}, PaperProps>(
  theme => ({
    root: {
      border: `1px solid ${theme.palette.primary.main}`,
      padding: theme.spacing(3),
      marginTop: theme.spacing(2),
      backgroundColor:
        theme.palette.type === 'dark'
          ? lighten(theme.palette.background.paper, 0.1)
          : darken(theme.palette.background.paper, 0.03)
    }
  }),
  {
    name: 'FdOrderViewPaper'
  }
)(Paper);
